import React, { useState, useContext } from 'react'
import { CartsAppContext } from '../context/carts-app-context'

const OrderReferrer = ({ itemId, referredByLabel, referredByHint }) => {
  const {
    cart,
    actions: { setCart }
  } = useContext(CartsAppContext)

  // itemId and item.id refer to the record number in the Items table
  const indexOfItemInCart = cart.items.findIndex(item => +item.id === +itemId)

  const [referrerText, setReferrerText] = useState(
    cart.items[indexOfItemInCart]['referrerName'] || ''
  )

  const handleRecTextChange = target => {
    const { value } = target
    setReferrerText(value)

    let newCart = {
      ...cart,
      ...(cart.items[indexOfItemInCart]['referrerName'] = value)
    }

    setCart(newCart)
  }

  return (
    <div id="referred-container">
      <br />
      <h4>{referredByLabel}</h4>
      <p>{referredByHint}</p>
      <div className="flex flex-wrap items-center">
        <div className="w-full my-8 string optional donation_form_preferred_recognition_name">
          <input
            type="text"
            id={`referrer-text-input-${indexOfItemInCart}`}
            className="string optional"
            maxLength="70"
            size="70"
            value={referrerText}
            aria-labelledby="preferred-recognition-fields"
            onChange={({ target }) => handleRecTextChange(target)}
          />
        </div>
      </div>
      <br />
    </div>
  )
}

export default OrderReferrer
